<template>
    <section>
        <b-overlay :show="loading" rounded="sm">
			<div class="card">
				<div class="card-header p-2">
					<div>
						<small class="float-left">Reviews:{{totalReviews}}</small>
						<b-form-checkbox v-model="chartOptionsModel.plotOptions.series.dataLabels.enabled" class="text-right" size="sm">
							{{ $t('dashboard.hideShowDataLabels') }}
						</b-form-checkbox>
					</div>
				</div>
				<span class="text-center m-5" v-if="empty">{{$t('global.ajaxTable.noRecordsFound')}}</span>
				<div class="card-body p-1" v-else>
					<chart :options="chartOptions"  ref="chart"></chart>
				</div>
			</div>
        </b-overlay>
    </section>
</template>

<script>

import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'
exportingInit(Highcharts)

export default {
    name: "ReviewPerDate",
    components:{ Chart },
    props: {
        filters: {
            type : Object,
            required: true
        },
        triggerSearch:{
            type : Number,
            required: true
        }
    },
    data() {
        let seriesExample = [{
            name:"",
            data:[]
        }];

        let schemeOptions = {
            title: {
                text: this.$t('dashboard.reviewPerDate')
            },
            tooltip: {
                enabled:true
            },
            yAxis: {
                title: {
                    text: 'Rate'
                },
                max: 5
            },
            exporting:{
                buttons:{
                    menuItems:["viewFullscreen"]
                }
            },
            xAxis:{
                type: 'category',
                categories:[],
                max:null,
            },
            series: seriesExample,
            plotOptions: {
                series: {
                    dataLabels: {
                        enabled: true
                    },
                }
            }
        }
        return {
            totalReviews:0,
            loading:false,
            exporting: {
                enabled: true
            },
            codeReport : "reviews-per-date",
            chartOptionsModel: {...schemeOptions},
            series:[]
        }
    },
    methods: {
        fetchDataChart(){
            this.loading=true;
            this.$root.api.get(`/dashboard/charts/${this.codeReport}`,{params: {filters:this.filters}}).then((res) => {
                this.totalReviews = res.data.totalReviews;
                this.series     = res.data.series;
                this.chartOptionsModel.series               = this.seriesTranslated;
                this.chartOptionsModel.xAxis.categories     = res.data.categories;

                console.log(this.totalReviews)
            })
            .catch(this.$root.handleRequestError)
            .finally(()=>{
                this.loading=false;
            })
        },
    },
    watch:{
        triggerSearch(){//este valor es reactivo, el padre decide en que momento se dispara la busqueda
            this.fetchDataChart();
        }
    },
    mounted() {
        if(this.triggerSearch>0){
            this.fetchDataChart();
        }
    },
    computed:{
        chartOptions(){
            return this.chartOptionsModel;
        },
        seriesTranslated(){
            return this.series.map((item)=>{
                let clonedItem = {...item}
                clonedItem.name = this.$t(item.name);
                return clonedItem
            })
        },
        empty(){
            return !(this.totalReviews>0)
        }
    }
}

</script>